import React from "react";
import { Quote } from "lucide-react";

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#C89D54]" />
          <span className="overline">Testimonials</span>
          <span className="h-px w-10 bg-[#C89D54]" />
        </div>

        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] tracking-tight leading-[1.05]">
          Words from those
          <span className="block italic text-[#C89D54]">I have helped.</span>
        </h2>

        <div
          data-testid="testimonials-placeholder"
          className="mt-14 mx-auto max-w-2xl border border-[#C89D54]/20 bg-[#262321]/60 backdrop-blur-sm px-8 py-14 md:py-16"
        >
          <Quote
            size={42}
            strokeWidth={1.2}
            className="mx-auto text-[#C89D54]/60"
          />
          <div className="mt-6 flex items-center justify-center gap-3">
            <span className="h-2 w-2 rounded-full bg-[#C89D54] pulse-dot" />
            <span className="overline text-[#C89D54]">Coming soon</span>
          </div>
          <p className="mt-4 font-serif-display text-2xl md:text-3xl italic text-[#F4F0EB] leading-snug">
            Genuine reviews from real clients will appear here.
          </p>
          <p className="mt-4 font-sans-body text-sm text-[#A6A098] max-w-md mx-auto">
            I believe in earning testimonials honestly — once new clients have
            been supported through their hearings, their words will be shared
            here with permission.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
